import Vue from 'vue'
import { getServerBrokerConfig } from '@/api'

const serverConfigInFlightPromises = new Map()

function normalizeServerId(serverId) {
  if (serverId === null || serverId === undefined || serverId === '') return ''
  return String(serverId)
}

function isFresh(entry, ttlMs) {
  return !!entry && Number(entry.updatedAt) > 0 && (Date.now() - Number(entry.updatedAt)) < ttlMs
}

export default {
  namespaced: true,
  state: () => ({
    configMap: {}
  }),
  getters: {
    getServerConfig: (state) => (serverId) => state.configMap[normalizeServerId(serverId)]?.data || null,
    getServerRoutes: (state, getters) => (serverId) => getters.getServerConfig(serverId)?.market_routes || {}
  },
  mutations: {
    SET_SERVER_CONFIG(state, { serverId, data, updatedAt = Date.now() } = {}) {
      const normalizedServerId = normalizeServerId(serverId)
      if (!normalizedServerId) return
      Vue.set(state.configMap, normalizedServerId, {
        data: data && typeof data === 'object' ? { ...data } : {},
        updatedAt
      })
    },
    REMOVE_SERVER_CONFIG(state, serverId) {
      const normalizedServerId = normalizeServerId(serverId)
      if (!normalizedServerId) return
      Vue.delete(state.configMap, normalizedServerId)
    }
  },
  actions: {
    async fetchServerConfig({ state, commit }, { serverId, force = false, ttlMs = 60000 } = {}) {
      const normalizedServerId = normalizeServerId(serverId)
      if (!normalizedServerId) return {}

      const cachedEntry = state.configMap[normalizedServerId]
      if (!force && isFresh(cachedEntry, ttlMs)) {
        return cachedEntry.data || {}
      }

      const inFlightPromise = serverConfigInFlightPromises.get(normalizedServerId)
      if (inFlightPromise) {
        return inFlightPromise
      }

      const requestPromise = getServerBrokerConfig(normalizedServerId)
        .then((res) => {
          const data = res?.data || {}
          commit('SET_SERVER_CONFIG', {
            serverId: normalizedServerId,
            data
          })
          return data
        })
        .finally(() => {
          serverConfigInFlightPromises.delete(normalizedServerId)
        })

      serverConfigInFlightPromises.set(normalizedServerId, requestPromise)
      return requestPromise
    },
    setServerConfig({ commit }, payload = {}) {
      commit('SET_SERVER_CONFIG', payload)
    },
    invalidateServerConfig({ commit }, serverId) {
      commit('REMOVE_SERVER_CONFIG', serverId)
    }
  }
}
